export const NEWEST_FIRST = 'newest_first'
export const PRICE_ASC = 'price_asc'
export const PRICE_DESC = 'price_desc'

export const SORT_METHOD_ROWS = [
  { text: '最新上架', value: NEWEST_FIRST },
  { text: '價錢由低至高', value: PRICE_ASC },
  { text: '價錢由高至低', value: PRICE_DESC }
]
